import React, { useEffect, useState } from 'react'
import { ICompanyMast } from '../../models/CompanyMast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Dialog } from 'primereact/dialog';
import { JVInput } from '../../shared/JVInput';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { baseUrl, Fetch } from '../../shared/Fetch';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { JVCheckbox } from '../../shared/JVCheckbox';
import { confirmDialog } from 'primereact/confirmdialog';


interface IProps {
    singleData: ICompanyMast;
    open: boolean;
    hideDialog: () => void;
    toast: any;
}


export interface ICompanyAuthorizedSignatory {
    id?: number;
    name: string;
    designation: string;
    comp_Id?: number;
    signature?: string;
    email?: string;
    contact_No?: string;
    is_Default?: boolean
}
const emptyFormData: ICompanyAuthorizedSignatory = {
    name: '',
    designation: '',
    email: '',
    contact_No: ''

}

const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    designation: yup.string().required('Designation is required'),
    email: yup.string().required('Email is required'),
    contact_No: yup.string().required('Contact is required'),
    is_Default: yup.boolean().nullable(),


});
export const CompanyAuthorizedSignatory = (props: IProps) => {
    const [loading, setLoading] = useState<Boolean>(false);
    const [signature, setSignature] = useState<File | null>(null);
    const [tableData, setTableData] = useState<ICompanyAuthorizedSignatory[]>([]);
    const [editingData, setEditingData] = useState<ICompanyAuthorizedSignatory | null>(null);


    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<ICompanyAuthorizedSignatory>({
        resolver: yupResolver(schema),
        defaultValues: {}
    });


    useEffect(() => {
        if (props.singleData.company_ID) {
            setValue('comp_Id', props.singleData.company_ID);
        }
    }, [props.singleData, setValue]);


    const proceedSubmit = async (data: any) => {
    setLoading(true);

    if (!signature && !editingData?.id) {
        props.toast.current.show({ severity: 'error', detail: "Please upload the Signature.", life: 3000 });
        setLoading(false);
        return;
    }

    const formData = new FormData();
    if (signature) {
        formData.append('signature', signature);
    }
    formData.append('data', JSON.stringify(data));

    const method = editingData?.id ? "PUT" : "POST";
    const message = editingData?.id ? "Updated Successfully" : "Posted Successfully";

    try {
        const response = await fetch(`${baseUrl}Company_Mast/Authorizedsignatory`, {
            method: method,
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`
            },
            body: formData
        });

        if (response.ok) {
            props.toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
            reset(emptyFormData);
            setSignature(null);
            setEditingData(null);
            LoadTableData();
        } else {
            const errorText = await response.text();
            console.error('Error:', errorText);
            props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save data', life: 3000 });
        }
    } catch (error) {
        console.error('Fetch error:', error);
        props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save data', life: 3000 });
    }

    setLoading(false);
};



    const onSubmit = async (data: any, event: any) => {
    data.comp_Id = props.singleData.company_ID;

    const existingDefault = tableData.find(d =>
        d.is_Default === true &&
        d.id !== editingData?.id // exclude current editing row
    );

    if (data.is_Default && existingDefault) {
        confirmDialog({
            message: `Signatory "${existingDefault.name}" is already marked as default. Do you want to update this as default instead?`,
            header: 'Confirm Default Change',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            accept: () => proceedSubmit(data),
            reject: () => { return; }
        });
    } else {
        proceedSubmit(data);
    }
};


    const LoadTableData = async () => {
        setLoading(true);
        const response = await Fetch("Company_Mast/getSignature", "GET", null, `comp_Id=${props.singleData.company_ID}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData(data);
        } else {
            props.toast.current.show({ severity: 'error', detail: "Failed To Load Designation List", life: 3000 });
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.open === true) {
            LoadTableData();
        }
    }, [props.open]);

    const uploadSignatory = (event: any) => {
        const file = event.files[0];
        setSignature(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Signature Selecetd", life: 3000 });
        event.options.clear();
    }

    const Action = (rowData: ICompanyAuthorizedSignatory) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary p-button-text" onClick={() => editSignatory(rowData)} />
            </>
        );
    };

    const editSignatory = (rowData: ICompanyAuthorizedSignatory) => {
        setEditingData(rowData);
    };

    useEffect(() => {
        if (editingData != null) {
            setValue('name', editingData.name);
            setValue('designation', editingData.designation);
            setValue('comp_Id', editingData.comp_Id);
            setValue('email', editingData.email);
            setValue('contact_No', editingData.contact_No);
            setValue('is_Default', editingData.is_Default);

            setValue('id', editingData.id)
        } else {
            reset(emptyFormData);
        }
    }, [editingData, setValue, reset]);

    const SignatureIcon = (rowData: ICompanyAuthorizedSignatory) => {
        return (
            <>
                <Button icon="pi pi-arrow-down" className="p-button-rounded p-button-text" onClick={() => signatureDownload(rowData)} tooltip="Download Signature" />
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" onClick={() => viewSignature(rowData)} tooltip="View Signature" />
            </>

        );
    };

    const signatureDownload = async (rowData: ICompanyAuthorizedSignatory) => {
        const Id = rowData.id;
        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token
                    }`
            },
        };
        try {
            const response = await fetch(`${baseUrl}Company_Mast/getdownloadSignature?Id=${Id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData.name}.png`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };

    const viewSignature = async (rowData: ICompanyAuthorizedSignatory) => {
        const Id = rowData.id;
        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || "")?.token}`,
            },
        };
        try {
            const response = await fetch(`${baseUrl}Company_Mast/viewSignature?Id=${Id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                // Open the image in a new tab
                window.open(href, '_blank');
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };


    const onHide = () => {
        props.hideDialog();
        reset(emptyFormData);
        setSignature(null)
        setEditingData(null);
    };
    const IsDefault = (rowData: any) => {
        return (
            <span className="text-cyan-700" >{rowData.is_Default ? "Yes" : "No"}</span>
        );
    };

    const header = () => {
        return <span> Add/Edit Signatory- <span style={{ color: "red" }}>({props.singleData.company_Name})</span> </span>
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className='p-fluid formgrid grid'>
                <JVInput column={6} name='name' required label='Name' control={control} error={errors.name?.message} />
                <JVInput column={6} name='designation' required label='Designation' control={control} error={errors.designation?.message} />
                <JVInput column={6} name='email' required label='Email' control={control} error={errors.email?.message} />
                <JVInput column={6} name='contact_No' required label='Contact No' control={control} error={errors.contact_No?.message} />
                <JVCheckbox className="mt-3" column={6} control={control} name="is_Default" label="Is Default" />
                <div className='mt-4 ml-3'>
                    <FileUpload mode="basic" name="signature" chooseLabel="Upload Signature" auto customUpload uploadHandler={uploadSignatory}  ></FileUpload>
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-start">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
            <div className=''>
                <DataTable style={{ fontSize: "15px", marginBottom: "10px" }} value={tableData} lazy dataKey="id" size="small" tableStyle={{ minWidth: "50rem", maxHeight: "3rem" }} showGridlines  >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="name" header="Signatory Name" />
                    <Column field="designation" header="Designation" />
                    <Column field="email" header="Email" />
                    <Column field="contact_No" header="Contact No." />
                    <Column field="is_Default" header="Is Default" body={IsDefault} />


                    <Column field='signature' header="Signature" body={SignatureIcon} />
                    <Column header="Action" body={Action} />
                </DataTable>
            </div>
        </Dialog>

    )
}
